import { useSelector } from "react-redux";
import PropertyDetailCard from "../PropertyDetailCard";
import Notification from "../../../../components/common/notification/Notification";


const Step5Preview = ({ form, onUpdate, prevStep, onSubmit }) => {
  const loggedInUser = useSelector((state) => state.auth.user);
  // console.log('form data', form)
  return (
    <div>
      <Notification />
      
      <PropertyDetailCard
        name={form.name}
        address={form.address}
        land_mark={form.area }
        pin_code={form.pin_code}
        city={form.cityName}
        state={form.stateName}
        country={'India'}
        structure={form.structure || {}}
        description={form.description || ""}
        feature={form.feature || {}}
        price={form.price || ""}
        propertyPurpose={form.propertyPurposeName}
        propertyType={form.propertyTypeName}
        property_sub_type={form.propertySubtypeName || ""}
        property_sub_sub_type={form.propertySubSubTypeName || ""}
        images={form.images} 
        videos={form.videos}  
        attachments={form.attachments}
        creater={`${loggedInUser.user.firstName} ${loggedInUser.user.lastName}`}
        photo={form.photo}
        /> 
        <div className="d-flex justify-content-between mt-4">
        <button className="btn btn-secondary" onClick={prevStep}>
          Previous
        </button>
        <div className='d-flex gap-4'>
          <button className="btn btn-warning" onClick={onUpdate}>
            Update
          </button>
          <button className="btn btn-success" onClick={onSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step5Preview;